<script>
export default {
    name: 'IconBook',
}
</script>
<template>
    <svg role="img"
        class="base-icon icon-book"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M20 8h32v44H28v4h-8V8zm-4 0v44h-4V8h4zm28 8H28v6h16v-6z"
            fill="currentColor"
            fill-rule="evenodd"
        />
    </svg>
</template>
